// src/context/AuthContext.js
import { createContext, useState, useEffect } from "react";
import axios from "../api/api";
import { jwtDecode } from "jwt-decode"; // Use named import

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem("token");

      if (token) {
        try {
          // Decode the token to check expiration and user data
          const decoded = jwtDecode(token); // Use jwtDecode directly

          const currentTime = Date.now() / 1000;
          if (decoded.exp && decoded.exp < currentTime) {
            localStorage.removeItem("token");
            setUser(null);
          } else {
            const isAdmin = decoded.isAdmin !== undefined ? decoded.isAdmin : false;
            if (isAdmin) {
              try {
                // Verify token with the backend
                await axios.get("/api/auth/verify", {
                  headers: { Authorization: `Bearer ${token}` },
                });
                setUser({
                  id: decoded.id || "unknown",
                  name: decoded.name || "Admin",
                  email: decoded.email || "unknown",
                  isAdmin: isAdmin,
                });
              } catch (err) {
                localStorage.removeItem("token");
                setUser(null);
              }
            } else {
              localStorage.removeItem("token");
              setUser(null);
            }
          }
        } catch (err) {
          localStorage.removeItem("token");
          setUser(null);
        }
      }
      setIsLoading(false);
    };
    verifyToken();
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
}